module.exports = __webpack_public_path__ + "static/media/linkedin.c17db4f8.svg";